module.exports = __webpack_public_path__ + "img/pck_vodovod.0dccb74b.jpg";